/**
 * What is said when a department has no seat for somebody: its dataspaces limit how many people may
 * have their processes open at once, and a refused write or a refused process view says so the same way
 * (`utils/seats.ts`). The Operator's own page for it is `operator.seat`, and the department's page
 * of seats is `departments.seats`.
 */
export default {
	seats: {
		unavailable: {
			// The count picks the form: none, one, many.
			named: "{department} has no seat for you: its license has no floating seats, and none is reserved for you. | The only floating seat in {department} is in use. | All {limit} floating seats in {department} are in use.",
			unnamed:
				"There is no seat for you in this department: its license has no floating seats, and none is reserved for you. | The only floating seat in this department is in use. | All {limit} floating seats in this department are in use.",
			// The server said too little to count with.
			anyNamed: "Every seat in {department} is in use.",
			any: "Every seat in this department is in use.",
			note: "A seat frees up about two minutes after the person holding it leaves, so try again in a moment.",
			noteNone:
				"Ask a department owner for a named seat, or for a license with floating seats.",
		},
	},
};
